import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/173/components/features/cases/OldComponents/cases/teboil/index.js");
